import { render, staticRenderFns } from "./IamPreferences.vue?vue&type=template&id=2d68b4bc&scoped=true&"
import script from "./IamPreferences.vue?vue&type=script&lang=ts&"
export * from "./IamPreferences.vue?vue&type=script&lang=ts&"
import style0 from "./IamPreferences.vue?vue&type=style&index=0&id=2d68b4bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68b4bc",
  null
  
)

export default component.exports